/**
 * `location` on a Banner is the page path the banner is authored for, not a placement enum.
 * Live values today: '/', '/trend', '/campaign/ggu-flash-sale', '/product'.
 *
 * The free-sample banner gets its own path rather than sharing '/product': Banner has no
 * "which slot on the page" field, so banners sharing a location can only be told apart by
 * `order` — and '/product' is already claimed by an unrelated PMax ad row.
 */
export const BANNER_LOCATION = {
  PRODUCT_DETAIL_FREE_SAMPLE: '/product/free-sample',
} as const;
